import { Text } from "@imminently/react/ui/core/text";
import { EmptyContent } from "@imminently/react/ui/core/empty-content";
import { Button, Stack } from "@mui/material";

export const Unauthorized = () => {
  return (
    <EmptyContent sx={{ backgroundColor: "white", color: "#000" }}>
      <Stack alignItems="center" gap={2}>
        <Text variant="h2">Unauthorized</Text>
        <Text>
          You do not have the appropriate permissions to access this portal.<br/>
          If this is an error, please contact your administrator.
        </Text>
        <Button sx={{ textTransform: "uppercase" }} href="/">
          return
        </Button>
      </Stack>
    </EmptyContent>
  );
};
